import React from 'react';
import { createLazyPage } from '../createLazyPage';
import { AppRouteDefinition } from '../routeDefinition';

const CashBackTravelPage = createLazyPage(
  () => import('@app/modules/cashBackTravel/pages/CashBackTravelPage')
);

const CashBackTravelAdminPage = createLazyPage(
  () => import('@app/modules/cashBackTravel/pages/CashBackTravelAdminPage')
);

export const cashBackRoutes: AppRouteDefinition[] = [
  {
    key: 'cash-back',
    path: 'cash-back',
    element: <CashBackTravelPage />,
  },
  {
    key: 'cash-back-admin',
    path: 'cash-back-admin',
    element: <CashBackTravelAdminPage />,
  },
];
